export default __webpack_public_path__ + "static/media/InactiveWaitlist.0299a23a.svg";